import { Component, OnInit, Input } from '@angular/core';
import {DrawFunctionDefaults, LeadToolsHelper} from '../../../models/configuration/draw/annotation-defaults.model';
import { DrawParameterObj } from '../../../models/configuration/draw/annotation-defaults.model';
import { cfgDrawParameter } from '../../../models/configuration/draw/annotation-defaults.model';
import { TdoColorPickerEvent } from '../../../tdo-controls/common/tdo-color-picker/models/tdo-color-picker.event';
import { DrawDefaultsService } from '../draw-defaults/draw-defaults.service';
import { DrawFont } from '../../../models/configuration/draw/annotation-defaults.model';
import { FontStyle } from '../../../models/configuration/draw/annotation-defaults.model';
import {TdoDropdownChange} from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import {ConfigurationService} from '../configuration.service';
import { MatSnackBar } from '@angular/material/snack-bar';

const ParamName = 'DEFAULT_FUNCTION_TOOLS';

@Component({
  selector: 'app-draw-function-tools',
  templateUrl: './draw-function-tools.component.html',
  styleUrls: ['./draw-function-tools.component.css']
})
export class DrawFunctionToolsComponent implements OnInit {
  leadToolsHelper: LeadToolsHelper = new LeadToolsHelper();
  FontSizes = [];
  enumFonts = [];
  enumFontStyles = [];
  currentFont: string;
  currentFontSize = 12;
  currentFontStyle: string;
  currentStampLocation: string;
  drawFonts = DrawFont;
  fontStyles = FontStyle;

  font: string;
  fontName: string;
  fontSize: number;
  fontStyle: string;
  foreground: string;
  background: string;
  showTickMarks: boolean;
  showGauge: boolean;

  public drawParameter: cfgDrawParameter;
  public drawFunctionDefaults: DrawFunctionDefaults;

  constructor(private drawDefaultService: DrawDefaultsService, public configurationService: ConfigurationService,  private snackBar: MatSnackBar) {
    this.enumFonts = Object.keys(this.drawFonts).filter(f => !isNaN(Number(f)));
    this.enumFontStyles = Object.keys(this.fontStyles).filter(f => !isNaN(Number(f)));
}
  getDrawParameters(parameterName: string) {
    let promise = new Promise((resolve, reject) => {
      this.drawDefaultService.getDrawDefaults(parameterName)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  ngOnInit(): void {
    for (let i = 6; i <= 25; i++) {
      let newSize = {
        value: i
      }
      this.FontSizes.push(newSize);
    }

    this.getDrawParameters(ParamName)
      .then((result: cfgDrawParameter) => {
        this.drawParameter = result;
        if (!this.drawParameter) {
          this.setDefaultValues();
          this.drawFunctionDefaults = new DrawFunctionDefaults();
          this.saveDefaultValues();
          return;
        }
        this.drawFunctionDefaults = JSON.parse(this.drawParameter.ParameterValue);
        this.font = this.drawFunctionDefaults.font;
        this.fontName = this.drawFunctionDefaults.fontName;
        this.fontSize = this.drawFunctionDefaults.fontSize;
        this.fontStyle = this.drawFunctionDefaults.fontStyle;
        this.foreground = this.drawFunctionDefaults.foreground;
        this.background = this.drawFunctionDefaults.background;
        this.showTickMarks = this.drawFunctionDefaults.showTickMarks;
        this.showGauge = this.drawFunctionDefaults.showGauge;

      }, err => {
        this.setDefaultValues();
        this.drawFunctionDefaults = new DrawFunctionDefaults();
        this.saveDefaultValues();
      });

  }

  setDefaultValues() {
    //Standard Stamp
    this.font = '0';
    this.fontName = this.drawFonts[this.font];
    this.fontSize = 12;
    this.fontStyle = '0';
    this.foreground = '#f05b41';
    this.background = '#5341f0';
    this.showTickMarks = true;
    this.showGauge = true;

  }
  saveDefaultValues() {
    this.drawFunctionDefaults.font = this.font;
    this.drawFunctionDefaults.fontSize = this.fontSize;
    this.drawFunctionDefaults.fontStyle = this.fontStyle;
    this.drawFunctionDefaults.foreground = this.foreground;
    this.drawFunctionDefaults.background = this.background;
    this.drawFunctionDefaults.showTickMarks = this.showTickMarks;
    this.drawFunctionDefaults.showGauge = this.showGauge;

  }

  onForegroundColorChange(event: TdoColorPickerEvent) {
    this.foreground = event.hex;
  }
  onBackgroundColorChange(event: TdoColorPickerEvent) {
    this.background = event.hex;
  }
  onFontChange(e) {
    this.font = e.value.value;
    this.fontName = e.value.name;
  }
  onFontSizeChange(e) {
    this.fontSize = e.value.value;
  }
  onFontStyleChange(e) {
    this.fontStyle = e.value.value;
  }
  async onSave(e) {
    this.saveDefaultValues();
    const drawParam = new DrawParameterObj();
    drawParam.parameterName = ParamName
    const annDefaults = JSON.stringify(this.drawFunctionDefaults);
    drawParam.parameterValue = annDefaults;
    await this.drawDefaultService.saveDrawDefaults('00000000-0000-0000-0000-000000000000', drawParam).toPromise();
    this.createMessage('Configuration Saved', 'Success');
    this.configurationService.setClean();
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  dropdownChange($event: TdoDropdownChange) {
    if ($event.isUserInput) {
      this.configurationService.setDirty();
    }
  }
}
